import { Paragraph } from 'component-library';
import { useTranslation } from 'react-i18next';
import { getPartnerDisplay } from '@sr/utils';
import { type PartnerResItem } from '@sr/types';
import { LocationWrapper, PartnerDescription } from './styles';

export type PartnerInfoProps = {
  partner?: PartnerResItem;
  boldTitle?: boolean;
  normalDescription?: boolean;
  includeLocationCount?: boolean;
};

/*
This component is used to display partner information in a unified manner
*/
export const PartnerInfo = ({
  partner,
  boldTitle,
  includeLocationCount,
  normalDescription,
}: PartnerInfoProps) => {
  const { t } = useTranslation();

  if (!partner) {
    return null;
  }

  const { nameAndText, addressAndId } = getPartnerDisplay(partner);

  const locationCountLabel =
    partner.locationCount > 1
      ? t('components.dropdown.locations')
      : t('components.dropdown.location');

  let description = addressAndId;

  if (includeLocationCount) {
    description = `${partner.locationCount} ${locationCountLabel}, ${addressAndId}`;
  }

  return (
    <LocationWrapper>
      <Paragraph bold={boldTitle} variant="large" data-testid="partnerInfo-name">
        {nameAndText}
      </Paragraph>
      <PartnerDescription normal={normalDescription} data-testid="partnerInfo-description">
        {description}
      </PartnerDescription>
    </LocationWrapper>
  );
};
